import { FC } from 'react';
import { useDispatch } from 'react-redux';
import { Modal } from 'react-bootstrap';
import { useTranslate } from 'hooks/useTranslate';

import { setModal } from 'modules/_shared/redux/modalActions';
import sizes, { ScreenSizes } from 'constants/sizes';
import CustomLoading from 'modules/_shared/components/CustomLoading';
import EmptyStateCard from 'modules/_shared/components/EmptyStates/EmptyStateCard';
import EnvelopeDetailsContent from 'modules/envelopes/pages/EnvelopeDetails/components/EnvelopeDetailsContent';
import { useGetEnvelopeDetails } from 'modules/envelopes/pages/EnvelopeDetails/hooks/useGetEnvelopeDetails';

type EnvelopeDetailsModalProps = {
  title: string;
  envelopeId: string;
  size?: ScreenSizes;
};

const EnvelopeDetailsModal: FC<EnvelopeDetailsModalProps> = ({
  title,
  envelopeId,
  size = sizes.XL, // eslint-disable-line
}) => {
  const { t } = useTranslate();
  const dispatch = useDispatch();

  const {
    data: envelope,
    isLoading,
    error,
    actions: { refetch },
  } = useGetEnvelopeDetails(envelopeId);

  const handleClose = () => {
    dispatch(setModal(null));
  };

  return (
    <>
      <Modal.Header>
        <h4 className="modal-title mb-0">
          <span>{title}</span>
        </h4>

        <a className="close cursor-pointer" onClick={handleClose}>
          <em className="icon ni ni-cross" />
        </a>
      </Modal.Header>

      <Modal.Body className="custom-modal-body bg-lighter">
        {isLoading && <CustomLoading />}

        {error || (!isLoading && !envelope) ? (
          <EmptyStateCard
            mainMessage={t('ErrorLoadingEnvelope')}
            infoMessage={t('ErrorLoadingEnvelopeMessage')}
            bordered={false}
          />
        ) : (
          envelope && (
            <div className="nk-modal">
              <EnvelopeDetailsContent
                envelope={envelope}
                refetchEnvelope={refetch}
              />
            </div>
          )
        )}
      </Modal.Body>
    </>
  );
};

export default EnvelopeDetailsModal;
